import {
  getActiveRestaurantId,
  getActiveStoreId,
  isSupermarketContext,
} from './entityContext';

/** Active restaurant or store for inventory suppliers / purchases. */
export function getInventoryOwnerContext() {
  if (isSupermarketContext()) {
    const storeId = Number(getActiveStoreId() || 0);
    return {
      storeId,
      ownerId: storeId,
      entityType: 'store',
      isStore: true,
    };
  }
  const restaurantId = Number(getActiveRestaurantId() || 0);
  return {
    restaurantId,
    ownerId: restaurantId,
    entityType: 'restaurant',
    isStore: false,
  };
}

/** POST/PUT body fields for supplier or purchase create/update. */
export function buildInventoryOwnerPayload(owner = getInventoryOwnerContext()) {
  if (owner.storeId > 0) {
    return { storeId: owner.storeId };
  }
  if (owner.restaurantId > 0) {
    return { restaurantId: owner.restaurantId };
  }
  return {};
}

export function getInventoryOwnerRequiredMessage() {
  return isSupermarketContext()
    ? 'Select a store to continue.'
    : 'Select a restaurant to continue.';
}
